import { TABLE_PARAMETERS, resolveTableParams } from './resolveTableParams'

export const presentationTableVariants = {
  default: {
    code: 'default',
    displayName: 'Default',
    description: 'Standard presentation table with neutral depth-banded rows and bordered headers.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  },
  flat: {
    code: 'flat',
    displayName: 'Flat',
    description: 'Clean, borderless table style. Suited for simple read-only data display.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  },
  glass: {
    code: 'glass',
    displayName: 'Glass',
    description: 'Translucent frosted-glass table with rounded corners and shadow. Best on colored backgrounds.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  },
  legacy: {
    code: 'legacy',
    displayName: 'Legacy',
    description: 'Classic table with full cell borders and darker depth-level shading.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  }
}
